<ng-container [formGroup]="editorForm">
  <div class="editor-wrapper">
    <div class="header">{{ header }}</div>
    <p-editor
      formControlName="descriptionControl"
      [placeholder]="placeholder"
      [style]="{'height':'320px'}"
      (onTextChange)="handleTextChange($event)"
      #descriptionEditor
    >
    </p-editor>
  </div>
</ng-container>
